import WDHForceTextHeight from '../../../../wdh-feature/wdh-text-image-spot/src/js/variations/force-text-height';
import WDHTextImageSpot from '../../../../wdh-feature/wdh-text-image-spot/src/js/wdh-text-image-spot';
var textImageSpot = new WDHTextImageSpot();
textImageSpot.registerVariation(new WDHForceTextHeight());
textImageSpot.run();